import moment from 'moment'

/**
* Get time diff between arguments.
*
* @param {moment.Moment} from
* @param {moment.Moment} to
* @param {boolean} [toTimeFormat=false]
* @param {boolean} [parse=false]
*
* @returns {string} time
*/
export default function getTimeDiff (_from, _to, toTimeFormat, parse = false) {
  const from = parse ? moment(_from) : _from
  const to = parse ? moment(_to) : _to

  const getTimeFromDuration = () => {
    const diff = from.diff(to)
    const duration = moment.duration(diff)
    time = Math.floor(duration.asHours()) + moment.utc(diff).format(':mm:ss')

    return time
  }

  const diffMetrics = {
    s: from.diff(to, 'second'),
    m: from.diff(to, 'minutes'),
    h: from.diff(to, 'hours'),
    d: from.diff(to, 'days'),
    w: from.diff(to, 'weeks'),
    mth: from.diff(to, 'months'),
    y: from.diff(to, 'years')
  }

  let time = ''

  if (diffMetrics.s < 60) {
    time = toTimeFormat ? getTimeFromDuration() : diffMetrics.s + ' s'
  } else if (diffMetrics.m < 60) {
    time = toTimeFormat ? getTimeFromDuration() : diffMetrics.m + ' min'
  } else if (diffMetrics.h < 24) {
    time = toTimeFormat ? getTimeFromDuration() : diffMetrics.h + ' h'
  } else if (diffMetrics.d < 7) {
    time = diffMetrics.d + ' d'
  } else if (diffMetrics.w < 5) {
    time = diffMetrics.w + ' w'
  } else if (diffMetrics.mth < 12) {
    time = diffMetrics.mth + ' m'
  } else {
    time = diffMetrics.y + ' y'
  }

  return time
}
